import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import Navigation from '@/components/Navigation';
import Hero from '@/components/Hero';
import Problem from '@/components/Problem';
import Services from '@/components/Services';
import Process from '@/components/Process';
import WhyUs from '@/components/WhyUs';
import FAQ from '@/components/FAQ';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import PrivacyPolicy from '@/components/PrivacyPolicy';
import ServicePage from '@/components/ServicePage';
import SERVICES from '@/data/services';
import { updatePageMeta } from '@/lib/seo';
import useReveal from '@/hooks/useReveal';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = () => {
  useEffect(() => {
    updatePageMeta({
      title: 'Business Process Automation & IT Consulting | Rapid Rune',
      description: 'Rapid Rune builds automation and IT systems that cut repetitive manual work. Your team focuses on what moves the business.',
      canonical: 'https://rapidrune.com/',
    });
  }, []);

  useReveal();

  return (
    <>
      <Navigation />
      <Hero />
      <Problem />
      <Services />
      <Process />
      <WhyUs />
      <FAQ />
      <Contact />
      <Footer />
    </>
  );
};

const PrivacyPage = () => {
  useEffect(() => {
    updatePageMeta({
      title: 'Privacy Policy - Rapid Rune',
      description: 'Privacy policy for Rapid Rune LLC, covering data collection, usage, and your rights.',
      canonical: 'https://rapidrune.com/privacy-policy',
    });
  }, []);

  return (
    <>
      <Navigation />
      <PrivacyPolicy />
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          {SERVICES.map((service) => (
            <Route
              key={service.slug}
              path={`/services/${service.slug}`}
              element={<ServicePage service={service} />}
            />
          ))}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
